import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelButtonLabel: {
    id: 'cancelButtonLabel',
    defaultMessage: 'Cancel',
  },
  closeDialogAriaLabelA11y: {
    id: 'closeDialogAriaLabelA11y',
    defaultMessage: 'Close dialogue',
  },
  cancelDialogAriaLabelA11y: {
    id: 'cancelDialogAriaLabelA11y',
    defaultMessage: 'Cancel and discard changes',
  },
});
